import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiEnum, HttpDataService } from './http-data.service';




@Injectable({
    providedIn: 'root'
})

export class CheckService{

    constructor(private readonly httpDataService: HttpDataService) {
    }

    checkBack(): Observable<string> {
        return this.httpDataService.get$<string>(ApiEnum.API_ROOT, environment.endpoint.check.checkBack, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<string>('checkBack'))
            );
    }

    CheckDatabaseConnection(): Observable<string> {
        return this.httpDataService.get$<string>(ApiEnum.API_ROOT, environment.endpoint.check.checkDatabase, null)
            .pipe(
                map((result) => {
                    return result;
                }),
                retry(3),
                catchError(this.httpDataService.handleError<string>('CheckDatabaseConnection'))
            );
    }

}

